import type { RegisterDeviceRequest } from '@/types/devices'
import { REGISTER_ERRORS, ROW_EXAMPLE, type CsvRowData } from './utils'

const getDeviceModel = (deviceSerial: string): string => {
  return deviceSerial.substring(0, 4)
}

const convertIsAttributeToBoolean = (isAttribute: string): boolean => {
  return ['Yes', 'y'].includes(isAttribute)
}

export const formatDeviceData = (deviceData: CsvRowData): RegisterDeviceRequest => {
  return {
    model: getDeviceModel(deviceData['Device Serial Number']),
    serial: deviceData['Device Serial Number'],
    cloud_state_data: {
      isIndoor: convertIsAttributeToBoolean(deviceData['Indoor Sensor?']),
      isPublic: convertIsAttributeToBoolean(deviceData['Make Device Public?']),
      longitude: parseFloat(deviceData.Longitude),
      latitude: parseFloat(deviceData.Latitude),
      name: deviceData['Device Name'],
      locationName: deviceData['Location Name']
    }
  }
}

export const formatRegisterError = (error: string, serialNumber: string): string => {
  for (const data of REGISTER_ERRORS) {
    if (data.errorRegex.test(error.toLowerCase())) {
      return data.parsedError.replace('/serialNumber/', serialNumber)
    }
  }

  return `${serialNumber} - ${error}`
}

export const sanitizeRows = (csvRows: CsvRowData[]): CsvRowData[] => {
  return csvRows.filter((row) => {
    return JSON.stringify(row) !== JSON.stringify({ ...ROW_EXAMPLE, RowId: row.RowId })
  })
}
